import React from 'react'
import { I13nDiv } from '@vzmi/ec-react-i13n'
import SalesPerformance from './OperatingDashboard/Mobile/SalesPerformance'
import styles from './MobileDashboard.css'

const MobileHeader = () => (
  <header className={styles.header}>
    供銷運籌管理
  </header>
)

const Dashboard = (props) => {
  const {
    supplier,
    actions,
    pageKey
  } = props
  const {
    fetchSalesPerformances
  } = actions
  const {
    sharedLink
  } = supplier

  return (
    <I13nDiv
      className={styles.dashboard}
    >
      <div
        className='pure-g'
        key={pageKey}
      >
        <div
          className='pure-u-1'
          {...props}
        >
          <MobileHeader />
          <SalesPerformance
            sharedLink={sharedLink}
            fetchSalesPerformances={fetchSalesPerformances}
            {...props}
          />
        </div>
      </div>
    </I13nDiv>
  )
}

export default Dashboard
